import SelectBox from 'components/global/SelectBox';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { setNextCompaignTab } from 'redux/actions/newCompaignActions';
import GoBackBtn from './GoBackBtn';

const AdditionalTargeting = () => {
    const [place , setPlace ] = useState('');
    const [venueType , setVenueType ] = useState('');
    const [adFormat , setAdFormat ] = useState('');
    const [contentSize , setContentSize ] = useState('');
    const [sensitiveContent , setSensitiveContent ] = useState('');
    const dispatch = useDispatch();

    const submitHandler = e => {
        e.preventDefault();
        dispatch(setNextCompaignTab());
    }

    return (
        <div className='sm:p-8 p-4 '>
            <GoBackBtn />
            <form onSubmit={submitHandler} className='flex flex-col gap-6'>
                <div className='flex items-center gap-5 sm:flex-row flex-col '>
                    <div className='flex-1 w-full'>
                        <SelectBox
                        options={[
                            { value : '1' , label : 'Outdoor'} ,
                            { value : '2' , label : 'Indoor'} ,
                            { value : '4' , label : 'Both outdoor & indoor'} ,
                        ]}
                        value={place}
                        setValue={setPlace}
                        placeholder='Choose Place'
                        // required
                        />
                    </div> 
                    <div className='flex-1 w-full'>
                        <SelectBox
                        options={[
                            { value : '1' , label : 'Venue Type 1'} ,
                            { value : '2' , label : 'Venue Type 2'} ,
                            { value : '3' , label : 'Venue Type 3'} ,
                            { value : '4' , label : 'Venue Type 4'} ,
                        ]}
                        value={venueType}
                        setValue={setVenueType}
                        placeholder='Select Venue Type'
                        // required
                        />
                    </div>
                </div>
                <div className='flex items-center gap-5 sm:flex-row flex-col '>
                    <div className='flex-1 w-full'>
                        <SelectBox
                        options={[
                            { value : '1' , label : 'Format 1'} ,
                            { value : '2' , label : 'Format 2'} ,
                            { value : '4' , label : 'Format 3'} ,
                        ]}
                        value={adFormat}
                        setValue={setAdFormat}
                        placeholder='Supported Ad Formats'
                        // required
                        />
                    </div> 
                    <div className='flex-1 w-full'>
                        <SelectBox
                        options={[
                            { value : '1' , label : 'Content Size 1'} ,
                            { value : '2' , label : 'Content Size 2'} ,
                            { value : '3' , label : 'Content Size 3'} ,
                            { value : '4' , label : 'Content Size 4'} ,
                        ]}
                        value={contentSize}
                        setValue={setContentSize}
                        placeholder='Ad Content Sizes'
                        // required
                        />
                    </div>
                </div>
                <div>
                    <SelectBox
                    options={[
                        { value : '1' , label : 'Sensitive Content Allowed'} ,
                        { value : '2' , label : 'Sensitive Content Not Allowed'} ,
                    ]}
                    value={sensitiveContent}
                    setValue={setSensitiveContent}
                    placeholder='Sensitive Content'
                    // required
                    />
                </div>
                <div className="mt-12 flex items-center gap-8 justify-center">
                    <button className="btn-primary py-1.5 w-[150px]">
                        Next
                    </button>
                </div>
            </form>
        </div>
    )
}

export default AdditionalTargeting